import {
  REPORT_FONT_FAMILY,
  type ReportFontData,
  type ReportFontStyle,
} from '@stratplan/report-engine/fonts';
export * from '@stratplan/report-engine/fonts';
const faces: Record<ReportFontStyle, string> = {
  normal: 'Regular',
  bold: 'Bold',
  italic: 'Italic',
  bolditalic: 'BoldItalic',
};
let ready: Promise<ReportFontData> | undefined;

export function loadReportFonts(): Promise<ReportFontData> {
  if (ready) return ready;
  ready = Promise.all(
    (Object.entries(faces) as [ReportFontStyle, string][]).map(async ([style, face]) => {
      const url = `${import.meta.env.BASE_URL}fonts/reports/LiberationSans-${face}.ttf`;
      const response = await fetch(url);
      if (!response.ok) throw new Error('Unable to load the report fonts. Please try again.');
      const bytes = new Uint8Array(await response.arrayBuffer());
      let binary = '';
      for (let i = 0; i < bytes.length; i += 8192)
        binary += String.fromCharCode(...bytes.subarray(i, i + 8192));
      if (typeof FontFace !== 'undefined' && typeof document !== 'undefined') {
        const font = new FontFace(REPORT_FONT_FAMILY, bytes, {
          weight: style.includes('bold') ? '700' : '400',
          style: style.includes('italic') ? 'italic' : 'normal',
        });
        document.fonts.add(await font.load());
      }
      return [style, btoa(binary)] as const;
    })
  )
    .then((entries) => Object.fromEntries(entries) as ReportFontData)
    .catch((error) => {
      ready = undefined;
      throw error;
    });
  return ready;
}
